import { customerService } from '../../helpers/services/customer.service';
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'
import i18n from '@/i18n'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const CUSTOMER_MODULE = 'customer';

// define action 
export const GET_CUSTOMER_BY_EMAIL = 'getCustomerByEmail';
export const GET_ALL_CUSTOMERS = 'getAllCustomers';
export const UPDATE_CUSTOMER_STATUS = 'updateCustomerStatus';
export const GET_CUSTOMER = 'getCustomer';
export const UPDATE_CUSTOMER = 'updateCustomer';
export const UNLOCK_CUSTOMER = 'unlockCustomer';
export const CREATE_CUSTOMER = 'createCustomer';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_CUSTOMERS_REQUEST = "getAllCustomers";
const GET_CUSTOMER_REQUEST = "getCustomer";

export const actions = {

    // eslint-disable-next-line no-unused-vars
    async [GET_CUSTOMER_BY_EMAIL]({ commit }, { email }) {
        await customerService
            .getCustomerByEmail(email)
            .then(
                (result) => {
                    commit(GET_CUSTOMER_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [GET_ALL_CUSTOMERS]({ commit }, { filter }) {
        customerService
            .getAllCustomers(filter)
            .then(
                (result) => {
                    commit(GET_ALL_CUSTOMERS_REQUEST, { data: result })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE);
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_CUSTOMER_STATUS]({ dispatch, commit }, { filter, data }) {
        customerService.updateCustomerStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_CUSTOMERS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE);
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    async [GET_CUSTOMER]({ commit }, { id }) {
        await customerService
            .getCustomer(id)
            .then(
                (result) => {
                    commit(GET_CUSTOMER_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE);
                }
            );
    },


    // eslint-disable-next-line no-unused-vars
    [UPDATE_CUSTOMER]({ commit }, { data }) {
        commit(REQUEST);
        customerService
            .updateCustomer(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.customer')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE);
                }
            );
    },


    // eslint-disable-next-line no-unused-vars
    [UNLOCK_CUSTOMER]({ dispatch, commit }, { id }) {
        commit(REQUEST);
        customerService.unlockCustomer(id)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    commit(SUCCESS);
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_CUSTOMER, { id })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE);
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_CUSTOMER]({ commit }, { redirectToCompany, data }) {
        commit(REQUEST);
        try {
            customerService
                .createCustomer(data)
                .then(
                    // eslint-disable-next-line no-unused-vars
                    (result) => {
                        var message = i18n.t("message.createXSuccess", [i18n.t('module.customer')]);
                        sharedHelper.alertSuccessMessage(message)
                        commit(SUCCESS);
                    },
                    (error) => {
                        let message = sharedHelper.getErrorMessage(error);
                        sharedHelper.alertErrorMessage(message, error.response.data.code)
                        commit(FAILURE);
                    }
                )
        } catch (error) {
            const message = sharedHelper.getErrorMessage(error);
            sharedHelper.alertErrorMessage(message, error.response?.data?.code);
            commit(FAILURE);
        }
    },
};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Customer-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_CUSTOMERS_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(d.pagination)

        state.list.data = d.data.map((o) => {
            return {
                uuid: o.uuid,
                firstName: o.first_name,
                lastName: o.last_name,
                referralBy: o.referral_by,
                email: o.email,
                phoneCode: o.phone_code,
                phoneIso: o.phone_iso,
                isActive: o.is_active,
                isShareCredit: o.is_share_credit,
                isReceivePromotionNews: o.is_receive_promotion_news,
                birthday: o.birthday,
                referralCode: o.referral_code,
                referralByType: o.referral_by_type,
                latestAgreeTermVersion: o.latest_agree_term_version,
                preferrenSendPromotionType: o.preferred_send_promotion_type,
                displayImageURL: o.display_image_url,
                customerVehicle: o.customer_vehicle,
                subCustomer: o.subCustomer,
                parentCustomer: o.parentCustomer,
                createdBy: o.created_by,
                createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
                updatedBy: o.updated_by,
                updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
            }
        })
    },
    [GET_CUSTOMER_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
            firstName: o.first_name,
            lastName: o.last_name,
            referralBy: o.referral_by,
            email: o.email,
            phoneCode: o.phone_code,
            phoneIso: o.phone_iso,
            isActive: o.is_active,
            isShareCredit: o.is_share_credit,
            isReceivePromotionNews: o.is_receive_promotion_news,
            birthday: o.birthday,
            referralCode: o.referral_code,
            referralByType: o.referral_by_type,
            latestAgreeTermVersion: o.latest_agree_term_version,
            preferrenSendPromotionType: o.preferred_send_promotion_type,
            displayImageURL: o.display_image_url,
            customerVehicle: o.customer_vehicle,
            subCustomer: o.subCustomer,
            parentCustomer: o.parentCustomer,
            createdBy: o.created_by,
            createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
            updatedBy: o.updated_by,
            updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
        }
    }
}


